import React from "react"
import { makeStyles } from "@material-ui/styles"
import ButtonBase from "@material-ui/core/ButtonBase"

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      ...theme.typography.button,
      backgroundColor: theme.palette[props.color].main,
      color: theme.palette[props.color].contrastText,
      border: "1px solid " + theme.palette[props.color].border,
      height: 48,
      zIndex: 2,
      padding: "0 20px",
      transition:
        "border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "&:hover": {
        border: "1px solid " + theme.palette[props.color].light,
        backgroundColor: theme.palette[props.color].light,
        color: theme.palette[props.color].hoverContrastText,
      },
      letterSpacing: "0.25px",
    }),
    disabled: props => ({
      borderColor: theme.palette[props.color].disabled,
      backgroundColor: theme.palette[props.color].disabled,
      color: theme.palette[props.color].contrastText,
    }),
    hover: props => ({
      border: "1px solid " + theme.palette[props.color].light,
      backgroundColor: theme.palette[props.color].light,
    }),
  }
})

export default props => {
  const { color, hover, outlined, className, ...newProps } = props
  const classes = useStyles(props)
  return (
    <ButtonBase
      {...newProps}
      className={[hover && classes.hover, className].join(" ")}
      classes={{
        root: classes.root,
        disabled: classes.disabled,
      }}
    >
      {props.children}
    </ButtonBase>
  )
}
